<div class="m-16">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content
    ><p>{{ data.message }}</p>
    <p>{{ data.question }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <su-button
      class="m-r-8"
      [label]="data.falseText ?? 'dialog.false' | translate"
      [mat-dialog-close]="false"
    ></su-button>
    <su-button
      [label]="data.trueText ?? 'dialog.true' | translate"
      [mat-dialog-close]="true"
    ></su-button>
  </mat-dialog-actions>
</div>
